/**
 * Helper functions for aliasing `DCP` keyfields.
 * @module
 */

var _ = require('optimizely-client-fn');
var Browser = require('core/utils/browser');
var Cookie = require('core/utils/cookie');
var Logger = require('core/utils/logger');
var WindowEnv = require('core/env/window');

/**
 * Keyfield locator types.
 * @type {Object.<string>}
 * @const
 * @private
 */
var keyFieldLocatorType = {
  COOKIE: 'cookie',
  JS_VARIABLE: 'js_variable',
  QUERY_PARAM: 'query_param',
  UID: 'uid',
};

/**
 * @param {DCPKeyfieldLocator[]} keyfieldLocators
 * @param {string} uid The Optimizely end user id.
 * @returns {Object.<string>} Current aliases as map of datasourceId to visitorIdInDatasource.
 */
exports.getCurrentAliases = function(keyfieldLocators:DCPKeyfieldLocator[], uid:string): Record<string, string> {
  var aliasParams = {} as any;
  _.each(keyfieldLocators, function(keyfieldLocator) {
    if (__INVARIANT__) {
      require('core/utils/invariant').isType('DCPKeyfieldLocator', keyfieldLocator);
    }
    if (keyfieldLocator.is_optimizely) {
      // We don't want to alias the Optimizely ID to itself.
      return;
    }
    var dcpDatasourceId = keyfieldLocator.dcp_datasource_id;
    var type = keyfieldLocator.type;
    // Can be undefined thanks to pruning of the DATA object.
    var name = keyfieldLocator.name || '';

    // We should never have a situation where the datasource id is undefined, but
    // check for this anyway.
    if (!dcpDatasourceId) {
      Logger.error('DCP / No DCP datasource id specified');
      return;
    }

    var visitorsIdInDatasource = null;
    switch(type) {
      case keyFieldLocatorType.COOKIE:
        visitorsIdInDatasource = Cookie.get(name);
        break;
      case keyFieldLocatorType.JS_VARIABLE:
        try {
          visitorsIdInDatasource = WindowEnv.getGlobal(name);
        } catch (e) {
          Logger.warn('Failed getting global DCP keyfieldLocator:', name);
        }
        break;
      case keyFieldLocatorType.QUERY_PARAM:
        visitorsIdInDatasource = Browser.getQueryParamValue(name);
        break;
      case keyFieldLocatorType.UID:
        visitorsIdInDatasource = uid;
        break;
    }

    if (_.isNumber(visitorsIdInDatasource) || _.isString(visitorsIdInDatasource)) {
      aliasParams[dcpDatasourceId] = visitorsIdInDatasource;
    }
  });

  return aliasParams;
};
